import React, { useState, useEffect } from "react"
import { useEffectOnceWhen } from "rooks"
import { Rect, Text, Image, Group } from "react-konva"
import '../Excelsior.css'
import WindowManager from '../useWindowManager'
// import Snackbar from '@mui/material/Snackbar'
// import MuiAlert from '@mui/material/Alert'

import { useSelector, useDispatch } from 'react-redux';
import { 
  setBuildGenerate
 } from '../store/readerSlice';


  // const Alert = React.forwardRef(function Alert(props, ref) {
  //   return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  // })

export const ExcelsiorRect = (props) => {

   //REDUX
   const dispatch = useDispatch()
   const buildBounding = useSelector(state => state.reader.buildBounding)
   const buildGenerate = useSelector(state => state.reader.buildGenerate)
   const setBuildGenerateStore = (v) => dispatch(setBuildGenerate(v))
   const currentPage = useSelector(state => state.reader.currentPage)
   const mode = useSelector(state => state.reader.mode)

  const [{
    size
}
] = WindowManager()



    const [annotations, setAnnotations] = useState([])
    const [newAnnotation, setNewAnnotation] = useState([])
    const [lastClick, setLastClick] = useState(null)

    const PANEL_MIN = 40

    const trash_svg = '<svg height="20px" width="20px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0{fill:#000000;} </style> <g> <path class="st0" stroke="#ffffff" stroke-width="10" d="M308.229,51.853C308,23.183,284.751,0.017,256,0c-28.734,0.017-52,23.183-52.228,51.853 c-63.821,9.2-109.796,33.323-109.796,49.845v16.718c0,20.784,72.538,37.625,162.024,37.625c89.486,0,162.024-16.841,162.024-37.625 v-16.718C418.024,85.176,372.049,61.053,308.229,51.853z M256,48.065c-6.245,0-12.376,0.196-18.433,0.498 c0.735-3.715,2.547-6.996,5.144-9.616c3.445-3.437,8.049-5.494,13.289-5.51c5.257,0.017,9.845,2.073,13.306,5.51 c2.595,2.62,4.408,5.902,5.135,9.616C268.384,48.261,262.245,48.065,256,48.065z"></path> <path class="st0" stroke="#ffffff" stroke-width="10" d="M256,178.335c-89.486,0-162.024-16.841-162.024-37.625l18.53,316.253C112.506,478.506,167.233,512,256,512 c88.767,0,143.51-33.494,143.51-55.037l18.514-316.253C418.024,161.494,345.486,178.335,256,178.335z M158.588,421.682 l-6.661-195.134c4.465,1.02,9.249,1.878,14.269,2.743l6.752,197.878C167.763,425.436,162.988,423.567,158.588,421.682z M217.176,436.98l-3.609-202.278c4.637,0.318,9.339,0.629,14.123,0.784l3.608,202.98C226.433,438.074,221.722,437.6,217.176,436.98 z M294.824,436.98c-4.547,0.62-9.339,1.094-14.196,1.486l3.608-202.98c4.784-0.155,9.494-0.466,14.123-0.784L294.824,436.98z M353.412,421.682c-4.392,1.886-9.175,3.755-14.351,5.486l6.744-197.878c5.02-0.865,9.803-1.796,14.277-2.743L353.412,421.682z"></path> </g> </g></svg>'  
    
    const trash_image = new window.Image()
    const trash_svgUrl = 'data:image/svg+xml;charset=UTF-8,'+encodeURIComponent(trash_svg)
    trash_image.src = trash_svgUrl


    useEffectOnceWhen(() => {
     
      // console.log(props.groupRef)
      // console.log(props.imageRef)

    }, [])

    useEffect(()=>{
      if(buildBounding === 'boundingbox' && mode === 'build') {
        document.body.style.cursor = "crosshair"
      }else{
        document.body.style.cursor = "default"
      }

        //
    }, [buildBounding, mode])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if(buildGenerate){
          setBuildGenerateStore(false)

          //Build here!
          var pgt = "pg" + currentPage.toString()
          var o = {
            [pgt]:{"panels":{"length":annotations.length}}
          }
    
          
          for(var i=0;i<annotations.length;i++){
            const coords = convertDimensionsToGroupCoords(annotations[i].x, annotations[i].y, annotations[i].width, annotations[i].height)
              o[pgt].panels["pn"+(i+1).toString()] = {
                "x":coords.x,
                "y":coords.y,
                "w":coords.w,
                "h":coords.h
              }
          }

          
          copyTextToClipboard(JSON.stringify(o))
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [buildGenerate])

    

    const copyTextToClipboard = (text) => {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text)
        return;
      }
      navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!')
      }, function(err) {
        console.error('Async: Could not copy text: ', err)
      });
    }
   const fallbackCopyTextToClipboard = (text) => {
      var textArea = document.createElement("textarea")
      textArea.value = text
      
      // Avoid scrolling to bottom
      textArea.style.top = "0"
      textArea.style.left = "0"
      textArea.style.position = "fixed"
    
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
    
      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
    
      document.body.removeChild(textArea);
    }
    
    const convertDimensionsToGroupCoords = (x,y,w,h) => {

      var imgRect = props.imageRef.current.getClientRect()
      var groupEl = props.groupRef.current   

      const groupScale = groupEl.attrs.scaleX
     
                 //Correct for group transform
                 imgRect.x -= groupEl.attrs.x
                 imgRect.y -= groupEl.attrs.y
                 imgRect.x /= groupScale
                 imgRect.y /= groupScale
                 imgRect.width /= groupScale
                 imgRect.height /= groupScale

                 const widthRatio = size.width / props.naturalWidth
                 const heightRatio = size.height / props.naturalHeight
                 const origScale = Math.min(widthRatio, heightRatio) / groupScale
   
          x -= imgRect.x
          y -= imgRect.y

          x /= origScale
          y /= origScale
          w /= origScale
          h /= origScale

        return {
        "x":Math.floor(x),
        "y":Math.floor(y),
        "w":Math.ceil(w),
        "h":Math.ceil(h)
      }
    }


    const handleCanvasDoubleClick = (e) => {
      // Code for double click event
      console.log("Double click detected")
      if(buildBounding !== 'boundingbox') {return}
      
      var imgRect = props.imageRef.current.getClientRect()
      var groupEl = props.groupRef.current   
              
                //Correct for group transform
                    imgRect.x -= groupEl.attrs.x
                    imgRect.y -= groupEl.attrs.y
                    imgRect.x /= groupEl.attrs.scaleX
                    imgRect.y /= groupEl.attrs.scaleX
                    imgRect.width /= groupEl.attrs.scaleX
                    imgRect.height /= groupEl.attrs.scaleX
            
            

      const annotationToAdd = {
        x: imgRect.x,
        y: imgRect.y,
        width: imgRect.width,
        height: imgRect.height,
        key: annotations.length + 1
      }
      annotations.push(annotationToAdd)
        setNewAnnotation([])
        setAnnotations(annotations)
  }
  
  const handleCanvasClick = (e) => {
      if (lastClick !== null && Date.now() - lastClick < 300) {
          handleCanvasDoubleClick(e)
          setLastClick(null)
      } else {
          setLastClick(Date.now())
          setTimeout(() => {
              if (lastClick === Date.now()) {
                  // Code for single click event
                 //console.log("Single click detected")
              }
          }, 300)
      }
  }
  
    const handleMouseDown = event => {
      if(buildBounding !== 'boundingbox') {return}
      if (newAnnotation.length === 0) {
        const { x, y } = event.target.getStage().getPointerPosition()
        setNewAnnotation([{ x, y, width: 0, height: 0, key: '0'}])
      }
      handleCanvasClick(event)
    };
  
    const handleMouseUp = event => {
      if(buildBounding !== 'boundingbox') {return}
      if (newAnnotation.length === 1) {
        const sx = newAnnotation[0].x
        const sy = newAnnotation[0].y
        const { x, y } = event.target.getStage().getPointerPosition()
        const annotationToAdd = {
          x: sx,
          y: sy,
          width: x - sx,
          height: y - sy,
          key: annotations.length + 1
        }
        if(x-sx < PANEL_MIN || y-sy < PANEL_MIN || sx > x || sy > y){
          setNewAnnotation([])
          return
        }
        annotations.push(annotationToAdd)
        setNewAnnotation([])
        setAnnotations(annotations)
      }
    };
  
    const handleMouseMove = event => {
      if(buildBounding !== 'boundingbox') {return}
      if (newAnnotation.length === 1) {
        const sx = newAnnotation[0].x
        const sy = newAnnotation[0].y
        const { x, y } = event.target.getStage().getPointerPosition()
        setNewAnnotation([
          {
            x: sx,
            y: sy,
            width: x - sx,
            height: y - sy,
            key: '0'
          }
        ]);
      }
    };
  
    const annotationsToDraw = [...annotations, ...newAnnotation]

    const deleteHandler = (e) => {
      var index = e.target.attrs.remove - 1
      var ary =  [...annotations.slice(0, index), ...annotations.slice(index + 1)]
      for(var i=e.target.attrs.remove - 1; i<ary.length;i++){
        ary[i].key = ary[i].key - 1
      }
      setAnnotations(ary)

    }

    return (
        
        <Group 
        onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseMove={handleMouseMove}
      width={size.width} 
      height={size.height} 
      listening={true}
        >
         
         <Rect 
                  x={0}
                  y={0}
                  width={size.width}
                  height={size.height}
         />
            {annotationsToDraw.map((value, index) => {
              return (
                <Group key={"g" + index.toString()}>
                <Rect
                  key={value.key}
                  x={value.x}
                  y={value.y}
                  width={value.width}
                  height={value.height}
                  fill="#00000045"
                  stroke="red"
                  strokeWidth={1}
                />
                <Group 
                key={"btns" + value.key.toString()}
                x={value.x}
                y={value.y}
                >
                    
                    <Text 
                    key={"txt" +value.key.toString()}
                    fontSize={20}
                    fill="white"
                    stroke="black"
                    strokeWidth={1}
                    fontStyle={"bold"}
                    text={value.key}
                    x={20}
                    y={0}
                     />
                     <Image
                     image={trash_image} 
                      onClick={(e) => deleteHandler(e)}
                      listening={true}
                      key={"img" +value.key.toString()}
                      remove={value.key}
                 
                    />
                </Group>
                </Group>
              );
            })}
      </Group>


  
    )
  }
